var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimplesNacional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 181,
    viewBox: "0 0 228 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1121 108.719H78.9148V103.02H62.501V126.957H69.1121V118.066H77.0911V112.709H69.1121V108.719Z",
    fill: "url(#paint0_linear_349_764)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0963 102.905L77.7754 126.842H84.5005L85.8683 122.169H92.3655L93.8473 126.842H100.572L92.2515 102.905H86.0963ZM86.8942 117.837L89.0599 110.428L91.2256 117.837H86.8942Z",
    fill: "url(#paint1_linear_349_764)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.302 119.661C115.96 120.003 115.618 120.345 115.162 120.573C114.706 120.801 114.25 121.029 113.794 121.029C113.339 121.143 112.883 121.143 112.427 121.143C111.515 121.143 110.831 120.915 110.147 120.573C109.463 120.231 108.893 119.775 108.437 119.205C107.981 118.635 107.639 117.951 107.297 117.153C107.069 116.355 106.955 115.557 106.955 114.759C106.955 114.075 107.069 113.278 107.297 112.48C107.525 111.682 107.867 110.998 108.323 110.428C108.779 109.858 109.349 109.288 110.033 108.946C110.717 108.604 111.515 108.376 112.427 108.376C112.883 108.376 113.339 108.376 113.794 108.49C114.25 108.604 114.706 108.718 115.162 108.946C115.618 109.174 116.074 109.516 116.416 109.858C116.758 110.2 117.1 110.77 117.328 111.34L122.343 107.806C121.545 106.211 120.292 104.957 118.582 104.045C116.872 103.133 114.82 102.563 112.541 102.563C110.603 102.563 108.893 102.905 107.411 103.589C105.93 104.273 104.562 105.185 103.536 106.324C102.51 107.464 101.712 108.718 101.142 110.086C100.572 111.454 100.344 112.936 100.344 114.417C100.344 115.899 100.572 117.495 101.256 118.977C101.826 120.459 102.624 121.826 103.764 122.966C104.904 124.106 106.157 125.132 107.525 125.816C109.007 126.5 110.603 126.956 112.427 126.956C113.453 126.956 114.478 126.842 115.504 126.614C116.644 126.386 117.556 126.044 118.468 125.474C119.38 125.018 120.178 124.448 120.976 123.764C121.659 123.08 122.229 122.282 122.571 121.371L117.214 118.179C116.872 118.863 116.644 119.319 116.302 119.661Z",
    fill: "url(#paint2_linear_349_764)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.462 102.905H124.851V126.842H131.462V102.905Z",
    fill: "url(#paint3_linear_349_764)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.063 121.143V102.905H135.452V126.842H152.891V121.143H142.063Z",
    fill: "url(#paint4_linear_349_764)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.23 102.905H94.9868L96.8106 107.921L100.23 102.905Z",
    fill: "url(#paint5_linear_349_764)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7596 67.3422C72.6457 67.2282 72.5317 67.1143 72.1897 66.8863C71.9617 66.6583 71.6198 66.5443 71.1639 66.4303C70.8219 66.2024 70.366 66.0884 69.91 65.9744C69.4541 65.8604 68.9981 65.7464 68.5422 65.7464C67.7443 65.7464 67.0604 65.8604 66.7184 66.2024C66.2625 66.5443 66.1485 66.8863 66.1485 67.4562C66.1485 67.7982 66.2625 68.0261 66.3765 68.2541C66.4905 68.4821 66.7184 68.7101 67.0604 68.824C67.2884 69.052 67.7443 69.166 68.2002 69.28C68.6562 69.394 69.1121 69.508 69.682 69.7359C70.4799 69.9639 71.1639 70.1919 71.7338 70.4198C72.4177 70.6478 72.8736 70.8758 73.2156 71.3317C73.6715 71.6737 74.0135 72.1296 74.2414 72.5856C74.4694 73.0415 74.5834 73.7254 74.5834 74.2953C74.5834 75.0932 74.4694 75.7771 74.1275 76.461C73.7855 77.031 73.4436 77.4869 72.8736 77.8289C72.3037 78.1708 71.7338 78.5128 71.0499 78.6268C70.366 78.8547 69.682 78.8547 68.8841 78.8547C67.7443 78.8547 66.6044 78.6268 65.4646 78.3988C64.3247 78.0568 63.4129 77.6009 62.501 76.917L63.8688 74.2953C63.9828 74.4093 64.2108 74.6373 64.5527 74.7513C64.8947 74.9792 65.2366 75.2072 65.8065 75.4352C66.2625 75.6632 66.8324 75.8911 67.2884 76.0051C67.8583 76.1191 68.4282 76.2331 68.9981 76.2331C70.5939 76.2331 71.5058 75.6632 71.5058 74.6373C71.5058 74.2953 71.3918 73.9534 71.2778 73.7254C71.0499 73.4974 70.8219 73.2695 70.4799 73.1555C70.138 72.9275 69.682 72.8135 69.2261 72.6995C68.7702 72.5855 68.2002 72.3576 67.6303 72.2436C66.8324 72.0156 66.2625 71.7877 65.6926 71.5597C65.1226 71.3317 64.6667 71.1037 64.3247 70.6478C63.9828 70.3059 63.6408 69.9639 63.5268 69.508C63.2989 69.052 63.2989 68.5961 63.2989 68.0261C63.2989 67.2282 63.4129 66.5443 63.7548 65.9744C64.0968 65.4045 64.4387 64.8346 65.0087 64.4926C65.4646 64.0367 66.1485 63.8087 66.7184 63.5807C67.4023 63.3527 68.0863 63.2388 68.8841 63.2388C70.024 63.2388 70.9359 63.4667 71.8478 63.6947C72.7596 63.9227 73.5575 64.3786 74.2414 64.9485L72.7596 67.3422Z",
    fill: "url(#paint6_linear_349_764)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0903 78.7405V63.3525H80.0539V78.7405H77.0903Z",
    fill: "url(#paint7_linear_349_764)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.013 78.7405V68.5959L92.0235 76.2329H90.4277L86.4382 68.5959V78.7405H83.4746V63.3525H86.6662L91.2256 72.1294L95.785 63.3525H98.9766V78.7405H96.013Z",
    fill: "url(#paint8_linear_349_764)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.51 78.7405V63.3525H109.007C109.691 63.3525 110.375 63.4665 110.945 63.8085C111.515 64.1504 112.085 64.4924 112.426 64.9483C112.882 65.4043 113.224 65.9742 113.452 66.5441C113.68 67.228 113.794 67.798 113.794 68.3679C113.794 69.0518 113.68 69.6217 113.452 70.3056C113.224 70.9895 112.882 71.4455 112.426 71.9014C111.971 72.3574 111.515 72.8133 110.945 73.0413C110.375 73.2692 109.691 73.4972 109.007 73.4972H105.359V78.6266H102.51V78.7405ZM105.473 70.8756H109.007C109.577 70.8756 110.033 70.6476 110.375 70.1916C110.717 69.7357 110.945 69.1658 110.945 68.3679C110.945 67.9119 110.945 67.684 110.717 67.342C110.489 67.0001 110.489 66.7721 110.261 66.5441C110.033 66.3162 109.805 66.2022 109.577 66.0882C109.349 65.9742 109.121 65.8602 108.779 65.8602H105.473V70.8756Z",
    fill: "url(#paint9_linear_349_764)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.188 78.7405V63.3525H119.152V76.1189H127.017V78.7405H116.188Z",
    fill: "url(#paint10_linear_349_764)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.668 76.1189V78.7405H128.954V63.3525H139.44V65.9742H131.917V69.7357H138.414V72.1294H131.917V76.1189H139.668Z",
    fill: "url(#paint11_linear_349_764)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.067 67.3422C150.953 67.2282 150.84 67.1143 150.498 66.8863C150.27 66.6583 149.928 66.5443 149.472 66.4303C149.13 66.2024 148.674 66.0884 148.218 65.9744C147.762 65.8604 147.306 65.7464 146.85 65.7464C146.052 65.7464 145.368 65.8604 145.026 66.2024C144.684 66.5443 144.456 66.8863 144.456 67.4562C144.456 67.7982 144.57 68.0261 144.684 68.2541C144.798 68.4821 145.026 68.7101 145.368 68.824C145.596 69.052 146.052 69.166 146.508 69.28C146.964 69.394 147.42 69.508 147.99 69.7359C148.788 69.9639 149.472 70.1919 150.042 70.4198C150.726 70.6478 151.181 70.8758 151.523 71.3317C151.979 71.6737 152.321 72.1296 152.549 72.5856C152.777 73.0415 152.891 73.7254 152.891 74.2953C152.891 75.0932 152.777 75.7771 152.435 76.461C152.093 77.031 151.751 77.4869 151.181 77.8289C150.612 78.1708 150.042 78.5128 149.358 78.6268C148.674 78.8547 147.99 78.8547 147.192 78.8547C146.052 78.8547 144.912 78.6268 143.772 78.3988C142.633 78.0568 141.607 77.4869 140.695 76.917L142.063 74.2953C142.177 74.4093 142.405 74.6373 142.747 74.7513C143.089 74.9792 143.43 75.2072 144 75.4352C144.456 75.6632 145.026 75.8911 145.482 76.0051C146.052 76.1191 146.622 76.2331 147.192 76.2331C148.788 76.2331 149.7 75.6632 149.7 74.6373C149.7 74.2953 149.586 73.9534 149.472 73.7254C149.244 73.4974 149.016 73.2695 148.674 73.1555C148.332 72.9275 147.876 72.8135 147.42 72.6995C146.964 72.5855 146.394 72.3576 145.824 72.2436C145.14 72.0156 144.456 71.7877 143.886 71.5597C143.316 71.3317 142.861 71.1037 142.519 70.6478C142.177 70.3059 141.835 69.9639 141.721 69.508C141.493 69.052 141.493 68.5961 141.493 68.0261C141.493 67.2282 141.607 66.5443 141.949 65.9744C142.177 65.4045 142.633 64.8346 143.202 64.4926C143.658 64.0367 144.342 63.8087 144.912 63.5807C145.596 63.3527 146.28 63.2388 147.078 63.2388C148.218 63.2388 149.13 63.4667 150.042 63.6947C150.953 64.0367 151.751 64.3786 152.435 64.9485L151.067 67.3422Z",
    fill: "url(#paint12_linear_349_764)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8947 88.8856V96.9785H62.501V84.3262H64.4387L71.0499 92.6471V84.3262H73.4436V96.9785H71.5058L64.8947 88.8856Z",
    fill: "url(#paint13_linear_349_764)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7127 84.439H81.8784L86.6658 97.0913H84.1581L83.0182 93.8997H78.5728L77.433 97.0913H74.9253L79.7127 84.439ZM82.5623 92.19L80.8525 87.1746L79.0288 92.19H82.5623Z",
    fill: "url(#paint14_linear_349_764)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8931 90.5956C86.8931 89.7977 87.0071 89.1138 87.349 88.3159C87.577 87.518 88.0329 86.8341 88.6028 86.2641C89.1728 85.6942 89.7427 85.1243 90.5406 84.7823C91.3385 84.4404 92.2504 84.2124 93.1623 84.2124C94.3021 84.2124 95.328 84.4404 96.2399 85.0103C97.1517 85.4662 97.7217 86.1501 98.1776 86.948L96.3538 88.3159C96.1259 87.9739 96.0119 87.632 95.7839 87.404C95.5559 87.176 95.328 86.948 94.986 86.8341C94.7581 86.7201 94.4161 86.6061 94.0741 86.4921C93.7322 86.4921 93.5042 86.3781 93.1623 86.3781C92.4783 86.3781 92.0224 86.4921 91.5665 86.7201C91.1105 86.948 90.6546 87.29 90.4266 87.632C90.0847 88.0879 89.8567 88.5438 89.7427 88.9998C89.6287 89.4557 89.5147 90.0256 89.5147 90.4816C89.5147 91.0515 89.6287 91.6214 89.7427 92.0774C89.9707 92.5333 90.1986 92.9893 90.5406 93.4452C90.8826 93.9011 91.2245 94.1291 91.6804 94.3571C92.1364 94.585 92.5923 94.699 93.1623 94.699C93.3902 94.699 93.7322 94.699 94.0741 94.5851C94.4161 94.4711 94.6441 94.3571 94.986 94.2431C95.214 94.1291 95.5559 93.9011 95.7839 93.6732C96.0119 93.4452 96.2399 93.1032 96.3538 92.7613L98.4056 93.9011C98.1776 94.3571 97.9496 94.813 97.4937 95.155C97.1517 95.4969 96.6958 95.8389 96.2399 96.0669C95.7839 96.2948 95.328 96.5228 94.758 96.6368C94.1881 96.7508 93.7322 96.8648 93.1623 96.8648C92.2504 96.8648 91.4525 96.6368 90.6546 96.2948C89.8567 95.8389 89.2868 95.3829 88.7168 94.813C88.1469 94.1291 87.8049 93.4452 87.463 92.7613C87.0071 92.1914 86.8931 91.3935 86.8931 90.5956Z",
    fill: "url(#paint15_linear_349_764)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8877 97.0913V84.439H102.281V97.0913H99.8877Z",
    fill: "url(#paint16_linear_349_764)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.375 97.0927C109.463 97.0927 108.665 96.8648 107.867 96.5228C107.069 96.1808 106.499 95.6109 105.93 95.041C105.36 94.4711 105.018 93.7872 104.676 92.9893C104.334 92.1914 104.22 91.3935 104.22 90.5956C104.22 89.6837 104.334 88.8858 104.676 88.2019C105.018 87.404 105.474 86.7201 106.043 86.1501C106.613 85.5802 107.297 85.0103 107.981 84.7823C108.779 84.4404 109.577 84.2124 110.489 84.2124C111.401 84.2124 112.199 84.4404 112.997 84.7823C113.794 85.1243 114.364 85.6942 114.934 86.2641C115.504 86.8341 115.846 87.632 116.188 88.3159C116.53 89.1138 116.644 89.7977 116.644 90.7096C116.644 91.6214 116.53 92.3053 116.188 93.1032C115.846 93.9011 115.504 94.5851 114.934 95.155C114.364 95.7249 113.68 96.1808 112.997 96.5228C112.085 96.9787 111.287 97.0927 110.375 97.0927ZM106.727 90.7096C106.727 91.2795 106.841 91.8494 106.955 92.3053C107.183 92.7613 107.411 93.2172 107.639 93.6732C107.981 94.1291 108.323 94.3571 108.779 94.5851C109.235 94.813 109.805 94.927 110.375 94.927C110.945 94.927 111.515 94.813 111.971 94.5851C112.427 94.3571 112.883 94.0151 113.111 93.6732C113.453 93.2172 113.68 92.7613 113.794 92.3053C114.022 91.8494 114.022 91.2795 114.022 90.8235C114.022 90.2536 113.908 89.6837 113.794 89.2277C113.567 88.7718 113.339 88.3159 113.111 87.8599C112.883 87.404 112.427 87.176 111.971 86.948C111.515 86.7201 111.059 86.6061 110.489 86.6061C109.919 86.6061 109.349 86.7201 108.893 86.948C108.437 87.176 107.981 87.518 107.753 87.8599C107.411 88.3159 107.183 88.7718 107.069 89.2277C106.727 89.6837 106.727 90.1396 106.727 90.7096Z",
    fill: "url(#paint17_linear_349_764)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.862 88.8856V96.9785H118.468V84.3262H120.406L127.017 92.6471V84.3262H129.411V96.9785H127.473L120.862 88.8856Z",
    fill: "url(#paint18_linear_349_764)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.679 84.439H137.845L142.633 97.0913H140.125L138.985 93.8997H134.54L133.4 97.0913H130.892L135.679 84.439ZM138.529 92.19L136.819 87.1746L134.996 92.19H138.529Z",
    fill: "url(#paint19_linear_349_764)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M144.114 97.0913V84.439H146.508V94.9256H153.005V97.0913H144.114Z",
    fill: "url(#paint20_linear_349_764)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1121 108.719H78.9148V103.02H62.501V126.957H69.1121V118.066H77.0911V112.709H69.1121V108.719Z",
    fill: "#4E4D4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0963 102.905L77.7754 126.842H84.5005L85.8683 122.169H92.3655L93.8473 126.842H100.572L92.2515 102.905H86.0963ZM86.8942 117.837L89.0599 110.428L91.2256 117.837H86.8942Z",
    fill: "#4E4D4D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.302 119.661C115.96 120.003 115.618 120.345 115.162 120.573C114.706 120.801 114.25 121.029 113.794 121.029C113.339 121.143 112.883 121.143 112.427 121.143C111.515 121.143 110.831 120.915 110.147 120.573C109.463 120.231 108.893 119.775 108.437 119.205C107.981 118.635 107.639 117.951 107.297 117.153C107.069 116.355 106.955 115.557 106.955 114.759C106.955 114.075 107.069 113.278 107.297 112.48C107.525 111.682 107.867 110.998 108.323 110.428C108.779 109.858 109.349 109.288 110.033 108.946C110.717 108.604 111.515 108.376 112.427 108.376C112.883 108.376 113.339 108.376 113.794 108.49C114.25 108.604 114.706 108.718 115.162 108.946C115.618 109.174 116.074 109.516 116.416 109.858C116.758 110.2 117.1 110.77 117.328 111.34L122.343 107.806C121.545 106.211 120.292 104.957 118.582 104.045C116.872 103.133 114.82 102.563 112.541 102.563C110.603 102.563 108.893 102.905 107.411 103.589C105.93 104.273 104.562 105.185 103.536 106.324C102.51 107.464 101.712 108.718 101.142 110.086C100.572 111.454 100.344 112.936 100.344 114.417C100.344 115.899 100.572 117.495 101.256 118.977C101.826 120.459 102.624 121.826 103.764 122.966C104.904 124.106 106.157 125.132 107.525 125.816C109.007 126.5 110.603 126.956 112.427 126.956C113.453 126.956 114.478 126.842 115.504 126.614C116.644 126.386 117.556 126.044 118.468 125.474C119.38 125.018 120.178 124.448 120.976 123.764C121.659 123.08 122.229 122.282 122.571 121.371L117.214 118.179C116.872 118.863 116.644 119.319 116.302 119.661Z",
    fill: "#4E4D4D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.462 102.905H124.851V126.842H131.462V102.905Z",
    fill: "#4E4D4D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M142.063 121.143V102.905H135.452V126.842H152.891V121.143H142.063Z",
    fill: "#4E4D4D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.23 102.905H94.9868L96.8106 107.921L100.23 102.905Z",
    fill: "#4E4D4D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7596 67.3422C72.6457 67.2282 72.5317 67.1143 72.1897 66.8863C71.9617 66.6583 71.6198 66.5443 71.1639 66.4303C70.8219 66.2024 70.366 66.0884 69.91 65.9744C69.4541 65.8604 68.9981 65.7464 68.5422 65.7464C67.7443 65.7464 67.0604 65.8604 66.7184 66.2024C66.2625 66.5443 66.1485 66.8863 66.1485 67.4562C66.1485 67.7982 66.2625 68.0261 66.3765 68.2541C66.4905 68.4821 66.7184 68.7101 67.0604 68.824C67.2884 69.052 67.7443 69.166 68.2002 69.28C68.6562 69.394 69.1121 69.508 69.682 69.7359C70.4799 69.9639 71.1639 70.1919 71.7338 70.4198C72.4177 70.6478 72.8736 70.8758 73.2156 71.3317C73.6715 71.6737 74.0135 72.1296 74.2414 72.5856C74.4694 73.0415 74.5834 73.7254 74.5834 74.2953C74.5834 75.0932 74.4694 75.7771 74.1275 76.461C73.7855 77.031 73.4436 77.4869 72.8736 77.8289C72.3037 78.1708 71.7338 78.5128 71.0499 78.6268C70.366 78.8547 69.682 78.8547 68.8841 78.8547C67.7443 78.8547 66.6044 78.6268 65.4646 78.3988C64.3247 78.0568 63.4129 77.6009 62.501 76.917L63.8688 74.2953C63.9828 74.4093 64.2108 74.6373 64.5527 74.7513C64.8947 74.9792 65.2366 75.2072 65.8065 75.4352C66.2625 75.6632 66.8324 75.8911 67.2884 76.0051C67.8583 76.1191 68.4282 76.2331 68.9981 76.2331C70.5939 76.2331 71.5058 75.6632 71.5058 74.6373C71.5058 74.2953 71.3918 73.9534 71.2778 73.7254C71.0499 73.4974 70.8219 73.2695 70.4799 73.1555C70.138 72.9275 69.682 72.8135 69.2261 72.6995C68.7702 72.5855 68.2002 72.3576 67.6303 72.2436C66.8324 72.0156 66.2625 71.7877 65.6926 71.5597C65.1226 71.3317 64.6667 71.1037 64.3247 70.6478C63.9828 70.3059 63.6408 69.9639 63.5268 69.508C63.2989 69.052 63.2989 68.5961 63.2989 68.0261C63.2989 67.2282 63.4129 66.5443 63.7548 65.9744C64.0968 65.4045 64.4387 64.8346 65.0087 64.4926C65.4646 64.0367 66.1485 63.8087 66.7184 63.5807C67.4023 63.3527 68.0863 63.2388 68.8841 63.2388C70.024 63.2388 70.9359 63.4667 71.8478 63.6947C72.7596 63.9227 73.5575 64.3786 74.2414 64.9485L72.7596 67.3422Z",
    fill: "#4E4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0903 78.7405V63.3525H80.0539V78.7405H77.0903Z",
    fill: "#4E4D4D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96.013 78.7405V68.5959L92.0235 76.2329H90.4277L86.4382 68.5959V78.7405H83.4746V63.3525H86.6662L91.2256 72.1294L95.785 63.3525H98.9766V78.7405H96.013Z",
    fill: "#4E4D4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M102.51 78.7405V63.3525H109.007C109.691 63.3525 110.375 63.4665 110.945 63.8085C111.515 64.1504 112.085 64.4924 112.426 64.9483C112.882 65.4043 113.224 65.9742 113.452 66.5441C113.68 67.228 113.794 67.798 113.794 68.3679C113.794 69.0518 113.68 69.6217 113.452 70.3056C113.224 70.9895 112.882 71.4455 112.426 71.9014C111.971 72.3574 111.515 72.8133 110.945 73.0413C110.375 73.2692 109.691 73.4972 109.007 73.4972H105.359V78.6266H102.51V78.7405ZM105.473 70.8756H109.007C109.577 70.8756 110.033 70.6476 110.375 70.1916C110.717 69.7357 110.945 69.1658 110.945 68.3679C110.945 67.9119 110.945 67.684 110.717 67.342C110.489 67.0001 110.489 66.7721 110.261 66.5441C110.033 66.3162 109.805 66.2022 109.577 66.0882C109.349 65.9742 109.121 65.8602 108.779 65.8602H105.473V70.8756Z",
    fill: "#4E4D4D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M116.188 78.7405V63.3525H119.152V76.1189H127.017V78.7405H116.188Z",
    fill: "#4E4D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M139.668 76.1189V78.7405H128.954V63.3525H139.44V65.9742H131.917V69.7357H138.414V72.1294H131.917V76.1189H139.668Z",
    fill: "#4E4D4D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M151.067 67.3422C150.953 67.2282 150.84 67.1143 150.498 66.8863C150.27 66.6583 149.928 66.5443 149.472 66.4303C149.13 66.2024 148.674 66.0884 148.218 65.9744C147.762 65.8604 147.306 65.7464 146.85 65.7464C146.052 65.7464 145.368 65.8604 145.026 66.2024C144.684 66.5443 144.456 66.8863 144.456 67.4562C144.456 67.7982 144.57 68.0261 144.684 68.2541C144.798 68.4821 145.026 68.7101 145.368 68.824C145.596 69.052 146.052 69.166 146.508 69.28C146.964 69.394 147.42 69.508 147.99 69.7359C148.788 69.9639 149.472 70.1919 150.042 70.4198C150.726 70.6478 151.181 70.8758 151.523 71.3317C151.979 71.6737 152.321 72.1296 152.549 72.5856C152.777 73.0415 152.891 73.7254 152.891 74.2953C152.891 75.0932 152.777 75.7771 152.435 76.461C152.093 77.031 151.751 77.4869 151.181 77.8289C150.612 78.1708 150.042 78.5128 149.358 78.6268C148.674 78.8547 147.99 78.8547 147.192 78.8547C146.052 78.8547 144.912 78.6268 143.772 78.3988C142.633 78.0568 141.607 77.4869 140.695 76.917L142.063 74.2953C142.177 74.4093 142.405 74.6373 142.747 74.7513C143.089 74.9792 143.43 75.2072 144 75.4352C144.456 75.6632 145.026 75.8911 145.482 76.0051C146.052 76.1191 146.622 76.2331 147.192 76.2331C148.788 76.2331 149.7 75.6632 149.7 74.6373C149.7 74.2953 149.586 73.9534 149.472 73.7254C149.244 73.4974 149.016 73.2695 148.674 73.1555C148.332 72.9275 147.876 72.8135 147.42 72.6995C146.964 72.5855 146.394 72.3576 145.824 72.2436C145.14 72.0156 144.456 71.7877 143.886 71.5597C143.316 71.3317 142.861 71.1037 142.519 70.6478C142.177 70.3059 141.835 69.9639 141.721 69.508C141.493 69.052 141.493 68.5961 141.493 68.0261C141.493 67.2282 141.607 66.5443 141.949 65.9744C142.177 65.4045 142.633 64.8346 143.202 64.4926C143.658 64.0367 144.342 63.8087 144.912 63.5807C145.596 63.3527 146.28 63.2388 147.078 63.2388C148.218 63.2388 149.13 63.4667 150.042 63.6947C150.953 64.0367 151.751 64.3786 152.435 64.9485L151.067 67.3422Z",
    fill: "#4E4D4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8947 88.8856V96.9785H62.501V84.3262H64.4387L71.0499 92.6471V84.3262H73.4436V96.9785H71.5058L64.8947 88.8856Z",
    fill: "#4E4D4D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7127 84.439H81.8784L86.6658 97.0913H84.1581L83.0182 93.8997H78.5728L77.433 97.0913H74.9253L79.7127 84.439ZM82.5623 92.19L80.8525 87.1746L79.0288 92.19H82.5623Z",
    fill: "#4E4D4D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8931 90.5956C86.8931 89.7977 87.0071 89.1138 87.349 88.3159C87.577 87.518 88.0329 86.8341 88.6028 86.2641C89.1728 85.6942 89.7427 85.1243 90.5406 84.7823C91.3385 84.4404 92.2504 84.2124 93.1623 84.2124C94.3021 84.2124 95.328 84.4404 96.2399 85.0103C97.1517 85.4662 97.7217 86.1501 98.1776 86.948L96.3538 88.3159C96.1259 87.9739 96.0119 87.632 95.7839 87.404C95.5559 87.176 95.328 86.948 94.986 86.8341C94.7581 86.7201 94.4161 86.6061 94.0741 86.4921C93.7322 86.4921 93.5042 86.3781 93.1623 86.3781C92.4783 86.3781 92.0224 86.4921 91.5665 86.7201C91.1105 86.948 90.6546 87.29 90.4266 87.632C90.0847 88.0879 89.8567 88.5438 89.7427 88.9998C89.6287 89.4557 89.5147 90.0256 89.5147 90.4816C89.5147 91.0515 89.6287 91.6214 89.7427 92.0774C89.9707 92.5333 90.1986 92.9893 90.5406 93.4452C90.8826 93.9011 91.2245 94.1291 91.6804 94.3571C92.1364 94.585 92.5923 94.699 93.1623 94.699C93.3902 94.699 93.7322 94.699 94.0741 94.5851C94.4161 94.4711 94.6441 94.3571 94.986 94.2431C95.214 94.1291 95.5559 93.9011 95.7839 93.6732C96.0119 93.4452 96.2399 93.1032 96.3538 92.7613L98.4056 93.9011C98.1776 94.3571 97.9496 94.813 97.4937 95.155C97.1517 95.4969 96.6958 95.8389 96.2399 96.0669C95.7839 96.2948 95.328 96.5228 94.758 96.6368C94.1881 96.7508 93.7322 96.8648 93.1623 96.8648C92.2504 96.8648 91.4525 96.6368 90.6546 96.2948C89.8567 95.8389 89.2868 95.3829 88.7168 94.813C88.1469 94.1291 87.8049 93.4452 87.463 92.7613C87.0071 92.1914 86.8931 91.3935 86.8931 90.5956Z",
    fill: "#4E4D4D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8877 97.0913V84.439H102.281V97.0913H99.8877Z",
    fill: "#4E4D4D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M110.375 97.0927C109.463 97.0927 108.665 96.8648 107.867 96.5228C107.069 96.1808 106.499 95.6109 105.93 95.041C105.36 94.4711 105.018 93.7872 104.676 92.9893C104.334 92.1914 104.22 91.3935 104.22 90.5956C104.22 89.6837 104.334 88.8858 104.676 88.2019C105.018 87.404 105.474 86.7201 106.043 86.1501C106.613 85.5802 107.297 85.0103 107.981 84.7823C108.779 84.4404 109.577 84.2124 110.489 84.2124C111.401 84.2124 112.199 84.4404 112.997 84.7823C113.794 85.1243 114.364 85.6942 114.934 86.2641C115.504 86.8341 115.846 87.632 116.188 88.3159C116.53 89.1138 116.644 89.7977 116.644 90.7096C116.644 91.6214 116.53 92.3053 116.188 93.1032C115.846 93.9011 115.504 94.5851 114.934 95.155C114.364 95.7249 113.68 96.1808 112.997 96.5228C112.085 96.9787 111.287 97.0927 110.375 97.0927ZM106.727 90.7096C106.727 91.2795 106.841 91.8494 106.955 92.3053C107.183 92.7613 107.411 93.2172 107.639 93.6732C107.981 94.1291 108.323 94.3571 108.779 94.5851C109.235 94.813 109.805 94.927 110.375 94.927C110.945 94.927 111.515 94.813 111.971 94.5851C112.427 94.3571 112.883 94.0151 113.111 93.6732C113.453 93.2172 113.68 92.7613 113.794 92.3053C114.022 91.8494 114.022 91.2795 114.022 90.8235C114.022 90.2536 113.908 89.6837 113.794 89.2277C113.567 88.7718 113.339 88.3159 113.111 87.8599C112.883 87.404 112.427 87.176 111.971 86.948C111.515 86.7201 111.059 86.6061 110.489 86.6061C109.919 86.6061 109.349 86.7201 108.893 86.948C108.437 87.176 107.981 87.518 107.753 87.8599C107.411 88.3159 107.183 88.7718 107.069 89.2277C106.727 89.6837 106.727 90.1396 106.727 90.7096Z",
    fill: "#4E4D4D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M120.862 88.8856V96.9785H118.468V84.3262H120.406L127.017 92.6471V84.3262H129.411V96.9785H127.473L120.862 88.8856Z",
    fill: "#4E4D4D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M135.679 84.439H137.845L142.633 97.0913H140.125L138.985 93.8997H134.54L133.4 97.0913H130.892L135.679 84.439ZM138.529 92.19L136.819 87.1746L134.996 92.19H138.529Z",
    fill: "#4E4D4D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M144.114 97.0913V84.439H146.508V94.9256H153.005V97.0913H144.114Z",
    fill: "#4E4D4D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M223.562 77.8286C216.723 65.9741 202.247 57.3112 180.475 51.726C166.683 35.882 145.368 22.3178 112.654 19.1262C104.447 12.5151 96.3544 6.47385 86.6657 3.16828C75.4951 -0.707213 64.0966 0.546623 54.7498 6.92979C47.9107 11.4892 42.3254 18.8982 38.4499 28.017C22.492 35.3121 10.2956 48.0784 4.25437 64.8343C-2.69873 83.8698 -0.98895 105.299 8.35783 125.36C7.55994 127.412 6.87603 129.578 6.07813 131.858C2.77256 142.458 4.14038 153.971 9.72566 163.545C14.741 171.98 22.378 177.566 31.2689 179.275C35.6003 180.073 39.5898 180.529 43.1233 180.529C55.8897 180.529 65.0085 175.742 77.3189 169.131C81.4223 166.965 85.9817 164.571 91.2251 161.95C94.4166 160.354 97.9502 159.1 101.598 157.846C113.452 154.883 124.965 153.401 136.477 158.53C140.011 160.126 143.658 161.95 147.192 163.887C157.223 169.017 167.937 174.602 178.538 174.602C185.491 174.602 192.33 172.208 198.827 165.711C203.5 160.924 207.034 148.157 207.262 131.972C214.671 127.754 220.826 121.257 224.93 110.086C229.489 98.2319 228.919 87.0614 223.562 77.8286ZM99.546 152.261C96.0124 153.173 92.5929 154.085 89.1733 155.111C67.0602 161.494 46.3149 167.535 25.9116 142.002C21.5801 136.531 17.9326 130.832 15.083 125.018C18.1606 117.267 21.4661 112.024 24.5437 107.009C31.2689 96.0662 37.0821 86.6054 38.3359 57.7672C38.6779 48.4204 40.3877 39.9855 43.1233 32.6904C46.9988 31.0946 51.1023 29.7268 55.3197 28.8149C76.635 24.4835 94.7586 23.5716 110.261 24.9394C110.944 25.5094 111.514 25.9653 112.198 26.4213C126.105 37.7058 141.834 50.3581 167.367 55.0315C170.787 55.6015 173.978 56.2854 177.056 57.0833C181.387 62.2126 184.921 67.5699 187.771 72.8132C197.801 91.5068 201.221 111.796 201.335 128.21C195.522 130.946 188.682 132.541 181.273 134.251C177.512 135.163 173.522 135.961 169.647 137.101C161.554 139.381 151.751 141.09 141.379 142.8C127.13 145.308 112.426 147.929 99.546 152.261ZM168.507 49.1043C147.762 45.3428 134.197 36.224 122.001 26.5352C143.088 30.4107 158.476 38.9596 169.647 49.3323C169.305 49.3323 168.963 49.2183 168.507 49.1043ZM58.2833 11.8312C63.0707 8.52558 68.428 6.92979 74.1273 6.92979C77.5468 6.92979 81.1944 7.6137 84.8419 8.86754C90.9971 11.0333 96.4684 14.4528 101.94 18.4423C87.9195 17.9864 72.3035 19.2402 54.2939 22.8877C51.6722 23.4576 49.2785 24.1416 46.7708 24.8255C49.8484 19.3542 53.61 14.9088 58.2833 11.8312ZM9.95363 66.886C14.741 53.6637 23.7458 43.1771 35.6003 36.338C33.7765 42.8351 32.6367 49.7882 32.2947 57.4252C31.1549 84.6677 25.9116 93.1026 19.4144 103.703C17.0207 107.579 14.399 111.91 11.7774 117.381C5.05227 100.512 4.25437 82.7299 9.95363 66.886ZM32.5227 173.348C25.3416 171.98 19.1864 167.307 15.083 160.468C10.2956 152.375 9.15573 142.686 12.0054 133.681C12.1193 133.339 12.2333 132.997 12.3473 132.655C14.969 137.101 17.9326 141.546 21.2382 145.764C37.538 166.167 54.1799 168.561 70.8217 165.825C57.2575 172.892 48.5946 176.54 32.5227 173.348ZM194.724 161.494C181.501 174.716 166.227 166.851 150.155 158.53C146.394 156.592 142.746 154.655 139.099 153.059C136.705 152.033 134.425 151.235 132.032 150.665C135.451 149.981 138.985 149.411 142.404 148.841C152.891 147.018 162.808 145.308 171.243 143.028C175.118 142.002 178.994 141.09 182.641 140.178C189.138 138.697 195.408 137.215 201.221 134.935C200.537 148.499 197.687 158.53 194.724 161.494ZM219.458 108.035C216.495 116.014 212.391 121.143 207.376 124.79C206.692 107.693 202.703 87.8593 193.128 69.9636C191.304 66.544 189.138 63.1245 186.859 59.8189C202.589 64.8343 213.189 71.9014 218.319 80.9062C222.764 88.6572 223.22 97.776 219.458 108.035Z",
    fill: "url(#paint21_linear_349_764)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_764",
    x1: 60.5723,
    y1: 104.816,
    x2: 75.8692,
    y2: 120.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_764",
    x1: 79.558,
    y1: 109.5,
    x2: 98.7244,
    y2: 128.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_349_764",
    x1: 103.762,
    y1: 106.066,
    x2: 121.145,
    y2: 123.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_349_764",
    x1: 120.481,
    y1: 107.271,
    x2: 135.777,
    y2: 122.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_349_764",
    x1: 131.162,
    y1: 107.271,
    x2: 151.89,
    y2: 127.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_349_764",
    x1: 95.4422,
    y1: 102.394,
    x2: 98.8818,
    y2: 105.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_349_764",
    x1: 63.2534,
    y1: 65.8662,
    x2: 74.0792,
    y2: 76.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_349_764",
    x1: 73.9787,
    y1: 66.41,
    x2: 83.1655,
    y2: 75.5969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_349_764",
    x1: 83.4959,
    y1: 63.2758,
    x2: 98.9509,
    y2: 78.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_349_764",
    x1: 100.721,
    y1: 65.0576,
    x2: 110.058,
    y2: 74.3941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_349_764",
    x1: 113.082,
    y1: 66.4098,
    x2: 126.184,
    y2: 79.5116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_349_764",
    x1: 127.812,
    y1: 64.5318,
    x2: 140.846,
    y2: 77.5655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_349_764",
    x1: 141.612,
    y1: 65.7958,
    x2: 152.487,
    y2: 76.6701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_349_764",
    x1: 62.0205,
    y1: 84.7814,
    x2: 73.8553,
    y2: 96.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_349_764",
    x1: 75.8576,
    y1: 88.2307,
    x2: 85.6783,
    y2: 98.0515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_349_764",
    x1: 88.5921,
    y1: 86.1704,
    x2: 97.6701,
    y2: 95.2483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_349_764",
    x1: 97.286,
    y1: 86.9411,
    x2: 104.844,
    y2: 94.4988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_349_764",
    x1: 105.876,
    y1: 86.2673,
    x2: 114.82,
    y2: 95.2119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_349_764",
    x1: 118.004,
    y1: 84.7814,
    x2: 129.838,
    y2: 96.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_349_764",
    x1: 131.795,
    y1: 88.2308,
    x2: 141.616,
    y2: 98.0516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_349_764",
    x1: 141.502,
    y1: 86.9411,
    x2: 152.296,
    y2: 97.7346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_349_764",
    x1: 28.2635,
    y1: 32.1989,
    x2: 180.394,
    y2: 184.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    stopColor: "#F9B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3324,
    stopColor: "#F6AC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#F09D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#E98836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#DF6C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#D54730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA142B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplesNacional);
export default __webpack_public_path__ + "static/media/simplesNacional.39337f41658b0af126fd50e0e233c150.svg";
export { ForwardRef as ReactComponent };